import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { CharacterPartType } from "../../dto/CharacterPartDTO";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import ClearCharacterPartsPreview from "../../features/previews/clear_character_parts/ClearCharacterPartsPreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { InteractionProperty } from "../InteractionProperty";
import Interaction, { InteractionType } from "./Interaction";
import { ISetCharacterParts } from "./SetCharacterParts";
import {
  compactSearchableStrings,
  SearchLookupContext,
} from "./SearchableInteractionValues";

export interface IClearCharacterParts extends Interaction {
  npcId: string;
  partsToClear: CharacterPartType[];
}

const requiredClearCharacterPartsProperties: InteractionProperty[] = [];

export const clearCharacterPartsInteraction = (): InteractionFactoryEntity => {
  const view = <ClearCharacterPartsPreview />;

  const create = (
    getKeys: (amount: number) => string[]
  ): IClearCharacterParts => {
    return {
      id: GetNewGuid(),
      name: "Clear Character Parts",
      type: InteractionType.ClearCharacterParts,
      npcId: "player",
      partsToClear: [],
      properties: requiredClearCharacterPartsProperties,
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): IClearCharacterParts => {
    return interaction as IClearCharacterParts;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void
  ): IClearCharacterParts => {
    const original = interaction as IClearCharacterParts;

    return {
      ...original,
      id: GetNewGuid(),
      partsToClear: [...original.partsToClear],
      properties: original.properties?.map((property) => ({ ...property })) ?? [],
    };
  };

  const validate = (interaction: Interaction): string[] => {
    const casted = interaction as IClearCharacterParts;
    const results: string[] = [];

    return results;
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[],
    _getValue: (key: string) => string,
    searchLookupContext?: SearchLookupContext,
  ): SearchResultData[] => {
    const casted = interaction as IClearCharacterParts;
    return getMatchingResults(
      compactSearchableStrings(
        interaction.name,
        searchLookupContext?.getActorSearchTerms(casted.npcId) ?? casted.npcId,
        casted.partsToClear.map((part) => CharacterPartType[part]),
      ),
      takeName,
      interaction,
      filterType
    );
  };

  const filterType: string = "Clear Character Parts";

  const validateError = (interaction: Interaction): string[] => {
    const casted = interaction as IClearCharacterParts;
    const errors: string[] = [];

    if (casted.partsToClear.length === 0) {
      errors.push("Please select at least one character part to clear");
    }

    return errors;
  };

  return {
    View: view,
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    FilterType: filterType,
    ValidateErrors: validateError,
  };
};
